var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1888 12C4.00013 12 3.82547 11.9003 3.7296 11.7379L3.14493 10.7489C1.9444 8.71947 0.810667 6.80267 0.423333 6.0252C0.141733 5.44773 0 4.8312 0 4.1888C0 1.87907 1.87907 0 4.1888 0C6.49853 0 8.3776 1.87907 8.3776 4.1888C8.3776 4.8308 8.23587 5.4472 7.95667 6.02093C7.95333 6.02787 7.9496 6.0348 7.946 6.0416C7.5512 6.82947 6.42467 8.734 5.23227 10.7495L4.648 11.7379C4.55213 11.9003 4.37747 12 4.1888 12Z",
    fill: "#CD2A3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18885 6.09045C3.05898 6.09045 2.13965 5.17125 2.13965 4.04139C2.13965 2.91152 3.05898 1.99219 4.18885 1.99219C5.31872 1.99219 6.23792 2.91152 6.23792 4.04139C6.23792 5.17125 5.31872 6.09045 4.18885 6.09045Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/addressIcon.8a7ad7d3d7051dc19942ed1c4d37745f.svg";
export { ForwardRef as ReactComponent };